import { useEffect } from "react";
import { useRouter } from "next/router";

const TRACKING_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
];

export function useTrackingParams() {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    const params: Record<string, string> = {};

    TRACKING_KEYS.forEach((key) => {
      const value = router.query[key];
      if (typeof value === "string" && value.trim() !== "") {
        params[key] = value;
      } else if (
        Array.isArray(value) &&
        typeof value[0] === "string" &&
        value[0].trim() !== ""
      ) {
        params[key] = value[0];
      }
    });

    if (Object.keys(params).length === 0) return;

    const expires = new Date();
    expires.setTime(expires.getTime() + 90 * 24 * 60 * 60 * 1000);

    TRACKING_KEYS.forEach((key) => {
      const value = params[key];
      if (!value) return;

      document.cookie = `${key}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
      localStorage.setItem(key, value);
    });
  }, [router.isReady, router.query]);
}
